export default __webpack_public_path__ + "static/media/react-poor-search.8346b05e.png";